import MuiContainer, { type ContainerProps } from '@mui/material/Container';

export type { ContainerProps };

const Container = (props: ContainerProps) => <MuiContainer {...props} />;

export default Container;
